import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

const EternityRing = () => {
    return (
        <>
            <Container className='dfl_custome_container_staticpage'>
                <Row className='w-100 m-auto'>
                    <Col sm={12} md={12} lg={12} className="p-0">
                        <div className='dfl_wedding_eternity_ring_section clearfix eternity_ring_content'>
                            <Row>
                                <Col sm={12} md={7} lg={6} xl={6}>
                                    <div className='text-center'>
                                        <h2>Eternity Rings</h2>
                                        <p>An eternity ring is the ultimate symbol of "YOURS FOREVER", whether it's for your wedding, an anniversary or simply to celebrate the joys of life. With diamonds encircling the band, these rings are the perfect expression of eternal love. Nothing speaks of FOREVER like an eternity ring does. Choose from a wide range of diamond sizes and shapes to find the perfect match for you. The options are limitless, VISIT DFL to find an eternity ring that is as unique and beautiful as your love story.</p>
                                        <NavLink to="/jewellery/wedding-rings/Eternity">Shop Eternity rings</NavLink>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>

        </>
    )
}

export default EternityRing